import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIResponseInterface } from '@core/interfaces/api-response.interface';
import { UserADInterface } from '@core/interfaces/user-ad.interface';
import { UserAuthorizeInterface } from '@core/interfaces/user-authorize.interface';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { UserRolesEnum } from '@core/enums/user-roles.enum';

@Injectable({ providedIn: 'root' })
export class UsersService {
    private currentUser: UserAuthorizeInterface | null = null;
    private _isAuthorize: BehaviorSubject<boolean | null> = new BehaviorSubject<
        boolean | null
    >(null);

    constructor(private http: HttpClient) {}

    getADUsers(): Observable<UserADInterface[]> {
        return this.http
            .get<APIResponseInterface<UserADInterface[]>>('users/ad')
            .pipe(map((response) => response.data));
    }

    getAuthorizeUser(): Observable<UserAuthorizeInterface> {
        return this.http
            .get<APIResponseInterface<UserAuthorizeInterface>>(
                'users/authorize'
            )
            .pipe(map((response) => response.data));
    }

    getUsers(): any[] {
        return [
            { name: 'Alex Johnson', id: '1' },
            { name: 'Alla Nefedova', id: '2' },
            { name: 'Anastasiya Norka', id: '3' },
            { name: 'Vladislav Sandrozd', id: '4' },
            { name: 'Alex Zhizhensky', id: '5' },
            { name: 'Pavel Bruyako', id: '6' },
        ];
    }

    setCurrentUser(user: UserAuthorizeInterface | null): void {
        this.currentUser = user;
        this.isAuthorize = !!user ? true : null;
    }

    getCurrentUserName(): string | null {
        return this.currentUser?.name || null;
    }

    isUserInRole(userRole: UserRolesEnum): boolean {
        return this.currentUser?.role === userRole;
    }

    getCurrentUser(): UserAuthorizeInterface | null {
        return this.currentUser;
    }

    set isAuthorize(flag: boolean | null) {
        this._isAuthorize.next(flag);
    }

    get isAuthorize() {
        return this._isAuthorize.getValue();
    }

    isAuthorizeChanges(): Observable<boolean | null> {
        return this._isAuthorize.asObservable();
    }
}
